import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { request } from "utils/request";

import { ItemsForm, ItemsListResponse } from "../types";
import { selectItemsForm } from "./selector";
import { itemsActions } from "./slice";

let isFetchingList = false;

export function* handleGetItemsList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const response: ItemsListResponse = yield call(
      request,
      `${API_URL}/item?page=1&perPage=20`,
      { method: "GET" },
    );

    yield put(itemsActions.getItemsListSuccess(response?.data || []));
  } catch (error) {
    yield put(itemsActions.getItemsListError((error as Error).message));
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddItem() {
  const form: ItemsForm = yield select(selectItemsForm);

  try {
    yield call(request, `${API_URL}/item`, {
      method: "POST",
      body: JSON.stringify({
        itemName: form.item.trim(),
        itemDesc: form.detailedDescription.trim(),
        height: Number(form.height),
        width: Number(form.width),
        thick: Number(form.thickness),
        length: Number(form.length),
        weight: Number(form.weight),
        itemType: form.group.trim(),
        remarks: form.notes.trim(),
      }),
    });

    yield put(itemsActions.addItemSuccess());
    yield put(itemsActions.getItemsList());
  } catch (error) {
    yield put(itemsActions.addItemError((error as Error).message));
  }
}

export function* itemsSaga() {
  yield takeLeading(itemsActions.getItemsList.type, handleGetItemsList);
  yield takeLatest(itemsActions.addItem.type, handleAddItem);
}

export default itemsSaga;
